<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="case-5">
<h1>Case 5</h1>
<div class="section level21" id="clinical-presentation-4">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Clinical Presentation</p>
<p style="text-indent:0px;">A 35-year-old woman, with history of dyspareunia and severe dysmenorrhoea for 5 years.</p>
</div>
<div class="section level21" id="radiological-findings-4">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Radiological Findings</p>
<p style="text-align: center;"><img alt="5" src="media/5.png"/></p>
<p style="padding-top: 15px;padding-bottom:10px; text-align: center;"></p>
<ul style="list-style:none;padding-right:120px;padding-left:140px;margin-top:0px;"><li>
<p style="text-indent:20px;"><strong>MR scan, axial T1 (A), T1 fat saturation (B, C), axial T2 (D) and post-contrast axial / sagittal T1 fat saturation (E, F) images</strong> showing multiple and bilateral well-circumscribed contiguous ovarian cystic lesions of high signal intensity on T1 and T1 fat saturation, low signal intensity on T2 with no peripheral enhancement after gadolinium administration (endometriomas). Both ovaries are closed up due to interovarian adhesions (Kissing ovaries). Note that the left ovary shows also another cystic lesion of high signal intensity on T1 and T2 with peripheral regular enhancement after gadolinium administration (haemorrhagic cyst, arrow in E and F). The uterus was normal.</p>
</li></ul>
<p style="text-indent:0px;padding-top:15px;"><strong>Diagnosis:</strong> Bilateral Ovarian Endometriomas with Coexisting Left Haemorrhagic Cyst</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch011.vue?2c5f72cc